module.exports = __webpack_public_path__ + "img/entrance_full.21a67ae4.jpg";